// Docs: https://docs.amplify.aws/lib/auth/getting-started/q/platform/js/#set-up-and-configure-amplify-auth
// Vite configuration: https://ui.docs.amplify.aws/react/getting-started/usage/vite#setup-and-installation
export default {
  Cognito: {
    // REQUIRED - Amazon Cognito Region
    region: import.meta.env.VITE_COGNITO_USER_POOL_REGION,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID,

    // OPTIONAL - This is used when autoSignIn is enabled for Auth.signUp
    // 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
    signUpVerificationMethod: "code", // 'code' | 'link'

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    authenticationFlowType: "USER_SRP_AUTH",

    // OPTIONAL - Set to true to use your identity pool's unauthenticated role when user is not logged in
    allowGuestAccess: false,

    loginWith: {
      // OPTIONAL - Hosted UI configuration
      oauth: {
        domain: import.meta.env.VITE_COGNITO_HOSTED_DOMAIN,
        scopes: [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin",
        ],
        redirectSignIn: [import.meta.env.VITE_COGNITO_REDIRECT_SIGN_IN],
        redirectSignOut: [import.meta.env.VITE_COGNITO_REDIRECT_SIGN_OUT],
        responseType: "code", // or 'token', note that REFRESH token will only be generated when the responseType is code
      },
    },
  },
};
